import { Grid, Typography } from '@mui/material';

export const Subtitle = ({ title }: { title: string }) => (
  <Grid item xs={12}>
    <Typography fontWeight={500}>{title}</Typography>
  </Grid>
);
